import type { TSelector } from "../../../../i18n/types";

export const pathMapping = {
  "Sponsored Display": "SD",
  "Sponsored Brand": "SB",
  "Sponsored Product": "SP",
  DSP: "DSP",
};

type PathLabelEntry = {
  label: TSelector;
  opacity: number;
};

export const pathLabelMapping: Record<"SD" | "SB" | "SP" | "DSP" | "ST", PathLabelEntry> = {
  SD: {
    label: ($) => $.amc["Sponsored Display"],
    opacity: 1,
  },
  SB: { label: ($) => $.amc["Sponsored Brand"], opacity: 0.9 },
  SP: { label: ($) => $.amc["Sponsored Product"], opacity: 0.8 },
  DSP: { label: ($) => $.amc["DSP"], opacity: 0.7 },
  ST: { label: ($) => $.amc["Streaming TV"], opacity: 0.6 },
};

export const parsePathToCampaignArray = (path: string): Array<{ name: string; type: string }> => {
  return path
    .slice(1, -1)
    .replaceAll(/\[(\d+),\s/g, "[$1: ")
    .split(",")
    .map((campaignName: string) => ({
      name: campaignName.slice(1, -1).split(":")[2] ?? "",
      type: campaignName.slice(1, -1).split(":")[1]?.trim() ?? "",
    }));
};

// oxlint-disable-next-line @typescript-eslint/no-explicit-any
export const castNumbersInRowData = (rowData: any) => {
  const isNumericString = (value: string): boolean => /^-?\d+(\.\d+)?$/.test(value.trim());
  if (typeof rowData === "object" && rowData !== null) {
    const keys = Object.keys(rowData);

    for (const key of keys) {
      rowData[key] = castNumbersInRowData(rowData[key]);
    }
  } else if (typeof rowData === "string" && isNumericString(rowData)) {
    return Number(rowData);
  }

  return rowData;
};
